import { Injectable } from '@angular/core';

import { getFirebaseBackend } from '../../authUtils';

import { User } from '../models/auth.models';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class AuthenticationService {

    user: User;

    constructor(private http: HttpClient) {
    }

    private apiUrl = '';

    /**
     * Returns the current user
     */
    public currentUser(): User {
        return getFirebaseBackend().getAuthenticatedUser();
    }

    /**
     * Performs the auth
     * @param email email of user
     * @param password password of user
     */
    login(email: string, password: string) {
        return this.http.post<any>(`${this.apiUrl}/auth/login`, { email, password });
        // return getFirebaseBackend().loginUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });
    }

    /**
     * Performs the register
     * @param email email
     * @param password password
     */
    register(userData: any) {
        return this.http.post<any>(`${this.apiUrl}/auth/register`, userData);
        // return getFirebaseBackend().registerUser(email, password).then((response: any) => {
        //     const user = response;
        //     return user;
        // });
    }

    /**
     * Reset password
     * @param email email
     */
    sendMailToResetPassword(email: string) {
        return this.http.post(`${this.apiUrl}/auth/password-reset-request`, { email })
    }

    resetPassword(data: any) {
        return this.http.post(`${this.apiUrl}/auth/password-reset`, data)
    }

    /**
     * Logout the user
     */
    logout() {
        // logout the user
        // getFirebaseBackend().logout();
        sessionStorage.clear();
    }
}

